import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EvadocEvaluacion } from '../model/evadoc-evaluacion';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EvadocCuestionarioService {

  url = `${environment.host}/api/cuestionario`;

  constructor(private http: HttpClient) { }

  ObtenerInstrucciones(uid: number): Observable<EvadocEvaluacion> {
    return this.http.get<EvadocEvaluacion>(`${this.url}/intrucciones/${uid}`).pipe(catchError(error => {
      console.log('Error service Cuestionario-obtenerInstrucciones', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }
}
